export enum ErrorType {
    EMAIL_ALREADY_IN_USE = 'E-mail se već koristi.',
    EMAIL_MISSING = 'Potrebno je unijeti e-mail.',
    NO_SUCH_USER = 'Nepostojeći korisnik.',
    AGENT_ALREADY_EXISTS = 'Agent već postoji.',
    INVALID_PASSWORD = 'Lozinka je neispravna',
    BRANCH_ACTIVE = 'Nemoguće izbrisati poslovnicu koja sadrži agente.',
    GENERIC = 'Greška u sustavu. Pokušajte kasnije.',
}
